
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-opacity":".01","fill":"#FFF","d":"M0 0h20v20H0z"}}),_c('path',{attrs:{"d":"M14.125 4.167a2.829 2.829 0 012.829 2.668l.004.155v1.44l.085.034a2.136 2.136 0 011.27 1.654l.015.148.005.15v4.798l-.082.082h-1.293v.603a.768.768 0 01-.593.747l-.087.016-.09.005a.77.77 0 01-.765-.678l-.005-.09v-.603H4.581v.603a.768.768 0 01-.594.747l-.086.016-.09.005a.77.77 0 01-.765-.678l-.005-.09v-.603H1.748l-.082-.082v-4.797a2.13 2.13 0 011.29-1.953l.084-.033V6.99a2.827 2.827 0 012.525-2.808l.153-.012.156-.004h8.25zM3.812 9.814a.604.604 0 00-.6.52l-.005.083v3.343h1.21v-3.343a.604.604 0 00-.523-.598l-.082-.005zm10.23 2.74H5.958v1.206h8.086v-1.205zm2.146-2.74a.604.604 0 00-.6.52l-.005.083v3.343h1.21v-3.343a.604.604 0 00-.523-.598l-.082-.005zm-2.063-4.112h-8.25c-.675 0-1.228.514-1.288 1.17l-.005.118v1.44l.084.034a2.133 2.133 0 011.286 1.802l.005.15v.603h8.086v-.602a2.13 2.13 0 011.29-1.953l.084-.033.001-1.44a1.29 1.29 0 00-1.175-1.284l-.118-.005z"}})])
          )
        }
      }
    